import type { Reference } from "@medplum/fhirtypes";

import { OpenStatementsRow, PayerDisplayCache } from "@/billing/types/open-statements";

/**
 * Returns every row's payer reference: an Organization for insurance, the client Patient for
 * self-pay.
 *
 * Payer names are resolved on the first Payer search rather than in `loadOpenStatements`: a
 * practice's statements can point at hundreds of distinct recipients, and reading them all up front
 * would slow every dashboard load to pay for a search most sessions never run.
 */
export function getOpenStatementsPayerReferences(rows: OpenStatementsRow[]): Reference[] {
  return rows.reduce<Reference[]>((references, row) => {
    if (row.payerReference) references.push(row.payerReference);
    return references;
  }, []);
}

/** The resolved payer name for a row, or `""` while it is unresolved or unreadable. */
export function getPayerDisplay(row: OpenStatementsRow, cache: PayerDisplayCache): string {
  const reference = row.payerReference?.reference;
  return (reference && cache.get(reference)) || "";
}
